//const
import {
	MODULE_NAME,
	CUSTOMERS,
	CUSTOMER_OPTIONS,
	GET_CUSTOMER_OPTION_NAME,
	GET_CUSTOMER_OPTION_IDS,
	SET_CUSTOMERS
} from '@/sections/options/options-mutation-type';

import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
	computed: {
		...mapGetters('options', [CUSTOMERS]),
		[CUSTOMER_OPTIONS]() {
			let customers = this[CUSTOMERS];
			if (!customers || !customers.items) {
				return { items: [] };
			}

			const totalCount = customers.totalCount;
			const items = customers.items.filter(
				item => item.text && item.value
			);

			if (items.length !== customers.items.length) {
				customers.counterPerPage = totalCount;
				customers.totalCount = totalCount;
			}

			return {
				...customers,
				items: items
			};
		}
	},
	methods: {
		...mapActions(MODULE_NAME, [SET_CUSTOMERS]),
		ddCustomerOptions(active = false) {
			const { items } = this[CUSTOMER_OPTIONS];
			let options = [];
			if (items && items.length) {
				options = [...items];
				if (active === true) {
					options = options.filter(x => x.active);
				}
				options = options.map(x => {
					return {
						text: x.text,
						value: x.value,
						dealershipGroupNumber: x.description
					};
				});
			}
			return options;
		},
		[GET_CUSTOMER_OPTION_NAME](value) {
			let { items } = this[CUSTOMER_OPTIONS];

			if (items && items.length) {
				if (Array.isArray(value)) {
					return items
						.filter(item => {
							return value.includes(item.value);
						})
						.map(item => item.text);
				}

				const customer = items.find(c => c.value === value);

				if (customer) {
					return customer.text;
				}
			}

			return '';
		},
		[GET_CUSTOMER_OPTION_IDS](customerName) {
			let { items } = this[CUSTOMER_OPTIONS];

			if (items && items.length) {
				return items
					.filter(item => {
						return (
							item.text &&
							item.text
								.toLowerCase()
								.includes(customerName.toLowerCase())
						);
					})
					.map(item => item.value);
			}

			return '';
		}
	},
	watch: {
		[CUSTOMERS]: {
			deep: true,
			immediate: true,
			handler(obj) {
				if (_.isEmpty(obj)) {
					this[SET_CUSTOMERS]();
				}
			}
		}
	}
};
